<div class="view-header flex-header">
  <div class="view-header-left">
    <h1 class="view-title">Assessments</h1>
    <p class="view-subtitle">Create and manage candidate assessments</p>
  </div>
  <button class="primary-btn button-deep-blue" (click)="openCreatePopup()">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="inline-plus-icon">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
    Create Assessment
  </button>
</div>

<!-- Filter bar -->
<div class="filters-bar">
  <div class="search-input-group">
    <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
    <input type="text" placeholder="Search assessments..." [(ngModel)]="assessmentSearchQuery">
  </div>
</div>

<!-- Assessment Layout Grid -->
<div class="assessments-layout-grid">
  <div class="assessment-card" *ngFor="let ass of filteredAssessments">
    
    <!-- Card Header with Clipboard Icon and Active badge -->
    <div class="assessment-card-header">
      <div class="assessment-icon-wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" class="clipboard-icon">
          <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
          <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
          <path d="M9 14h6"></path>
          <path d="M9 18h6"></path>
          <path d="M9 10h6"></path>
        </svg>
      </div>
      <span class="assessment-status-badge">Active</span>
    </div>

    <!-- Card Body: Title and Horizontal metrics -->
    <div class="assessment-card-body">
      <h3 class="assessment-card-title">{{ ass.title }}</h3>
      
      <div class="assessment-horizontal-metrics">
        <div class="metric-item duration">
          <svg class="metric-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          <span class="metric-val">{{ ass.duration }} min</span>
        </div>
        <div class="metric-item questions">
          <span class="metric-val">{{ ass.questionsCount }} Q</span>
        </div>
        <div class="metric-item candidates">
          <svg class="metric-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
          <span class="metric-val">{{ ass.candidatesCount }}</span>
        </div>
      </div>
    </div>

    <!-- View candidates flat bottom button -->
    <div class="assessment-card-footer">
      <button class="flat-candidates-btn" (click)="openCandidatesPopup(ass)">
        View Candidates
      </button>
    </div>
  </div>
</div>

<!-- ==========================================
     CREATE ASSESSMENT MODAL POPUP
     ========================================== -->
<div class="modal-backdrop-blur" *ngIf="isCreatePopupOpen">
  <div class="modal-window-card compact-card fade-in-panel">
    
    <!-- Modal Header -->
    <div class="modal-header-row">
      <div class="modal-header-text">
        <h2 class="modal-title">Create Assessment</h2>
        <p class="modal-subtitle">Configure a new assessment</p>
      </div>
      <button class="modal-close-icon-btn" (click)="closeCreatePopup()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>

    <!-- Form Content Area -->
    <div class="modal-content-area">
      <div class="form-control margin-bottom-form">
        <span class="form-label">Title</span>
        <input type="text" [(ngModel)]="newTitle" placeholder="e.g. Full Stack Developer - React + Node" class="modal-input-field">
      </div>
      
      <div class="form-row-split-50">
        <div class="form-control">
          <span class="form-label">Duration</span>
          <input type="text" [(ngModel)]="newDuration" placeholder="60 min" class="modal-input-field">
        </div>
        <div class="form-control">
          <span class="form-label">Questions</span>
          <div class="spinner-input-wrapper">
            <input type="number" [(ngModel)]="newQuestionsCount" placeholder="35" class="modal-input-field spinner-input">
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer Actions -->
    <div class="modal-footer-row">
      <button class="btn-modal-cancel" (click)="closeCreatePopup()">Cancel</button>
      <button class="btn-modal-submit" (click)="createAssessment()">Create</button>
    </div>

  </div>
</div>

<!-- ==========================================
     VIEW CANDIDATES MODAL POPUP
     ========================================== -->
<div class="modal-backdrop-blur" *ngIf="isCandidatesPopupOpen">
  <div class="modal-window-card wider-card fade-in-panel">
    
    <!-- Modal Header -->
    <div class="modal-header-row">
      <div class="modal-header-text">
        <h2 class="modal-title">{{ selectedAssessment?.title }}</h2>
        <p class="modal-subtitle">Candidates who took this assessment</p>
      </div>
      <button class="modal-close-icon-btn" (click)="closeCandidatesPopup()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>

    <!-- Candidates Table Content Area -->
    <div class="modal-content-area no-padding-bottom">
      
      <!-- If there are candidates -->
      <div class="candidates-table-wrapper" *ngIf="assessmentCandidates && assessmentCandidates.length > 0">
        <table class="candidates-list-table">
          <thead>
            <tr>
              <th class="col-candidate">Candidate</th>
              <th class="col-score">Score</th>
              <th class="col-status">Status</th>
              <th class="col-action">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let cand of assessmentCandidates">
              <!-- Name & Email -->
              <td class="col-candidate">
                <div class="candidate-meta">
                  <div class="cand-name">{{ cand.name }}</div>
                  <div class="cand-email">{{ cand.email }}</div>
                </div>
              </td>
              
              <!-- Score -->
              <td class="col-score">
                <span class="cand-score" [ngClass]="{
                  'score-high': cand.score >= 80,
                  'score-mid': cand.score >= 70 && cand.score < 80,
                  'score-low': cand.score < 70
                }">
                  {{ cand.score }}/100
                </span>
              </td>
              
              <!-- Status Capsule Badge -->
              <td class="col-status">
                <span class="status-badge" [ngClass]="{
                  'badge-shortlisted': cand.status === 'Shortlisted',
                  'badge-applied': cand.status === 'Applied',
                  'badge-selected': cand.status === 'Selected',
                  'badge-rejected': cand.status === 'Rejected'
                }">
                  {{ cand.status }}
                </span>
              </td>
              
              <!-- Action View Report -->
              <td class="col-action">
                <button class="action-btn-view-report">
                  <!-- Eye Icon -->
                  <svg class="eye-icon" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                  View Report
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Empty state if no candidates took the assessment yet -->
      <div class="empty-candidates-state" *ngIf="!assessmentCandidates || assessmentCandidates.length === 0">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="empty-icon">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <line x1="23" y1="11" x2="17" y2="11" />
        </svg>
        <p class="empty-state-title">No Candidates Yet</p>
        <p class="empty-state-desc">Candidates who take this assessment will appear here.</p>
      </div>

    </div>

  </div>
</div>
